import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
// Optionale Felder sind als nullable Variablen typisiert; undefined -> null
// (statt bisher der Literalstring "undefined"). Schützt gegen Stored-Injection
// insbesondere über trackingId.
export const createRecyclingProcessMutation: DocumentNode = gql`
  mutation CreateRecyclingProcess(
    $correlationId: String!
    $processStart: DateTime!
    $chosenProductCategoryId: String!
    $chosenManufacturer: String!
    $countryId: String!
    $trackingId: String
    $dateOfArrival: DateTime
    $arrivedProductCategoryId: String
    $serialNumber: String
  ) {
    createRecyclingProcess(input: {
      correlationId: $correlationId
      processStart: $processStart
      chosenProductCategoryId: $chosenProductCategoryId
      chosenManufacturer: $chosenManufacturer
      countryId: $countryId
      trackingId: $trackingId
      dateOfArrival: $dateOfArrival
      arrivedProductCategoryId: $arrivedProductCategoryId
      serialNumber: $serialNumber
    })
    {
      recyclingProcess {
        id
        correlationId
        processStart
        chosenProductCategoryId
        chosenManufacturer
        countryId
        trackingId
        dateOfArrival
        arrivedProductCategoryId
        serialNumber
      }
    }
  }
`;
